import { render, staticRenderFns } from "./VideoListPlugin.vue?vue&type=template&id=7f670b83&scoped=true&"
import script from "./VideoListPlugin.vue?vue&type=script&lang=js&"
export * from "./VideoListPlugin.vue?vue&type=script&lang=js&"
import style0 from "./VideoListPlugin.vue?vue&type=style&index=0&id=7f670b83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f670b83",
  null
  
)

export default component.exports